import { render, staticRenderFns } from "./AppNoticeView.vue?vue&type=template&id=6215eea7&"
import script from "./AppNoticeView.vue?vue&type=script&lang=js&"
export * from "./AppNoticeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports